import {
  CheckUserPermissionsCommandInput,
  UserNotFoundException,
  UserInactiveException,
} from '@amzn/gbsa-orbit-typescript-client';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Permission, permissionsArray } from 'src/contstant/permissionAccessConfig';
import { userKeys } from 'src/data/api/orbit-service-ts/user/queries/keys';
import { userService } from 'src/data/api/orbit-service-ts/user/userService';

export const useUserPermissionsQuery = <TData = Set<Permission>>(
  {
    programId,
    userId: userAlias,
    businessUnit,
    divisions,
  }: Partial<CheckUserPermissionsCommandInput>,
  options?: Omit<
    UseQueryOptions<Set<Permission>, Error, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    ...options,
    queryKey: userKeys.permissions({ userAlias, programId, businessUnit, divisions }),
    enabled: !!userAlias && !!programId && !!businessUnit && !!divisions,
    queryFn: async () => {
      if (!userAlias || !programId || !businessUnit || !divisions) {
        throw new Error('Missing required parameters');
      }
      try {
        const resp = await userService.checkUserPermission({
          permissions: permissionsArray,
          programId: programId,
          userId: userAlias,
          businessUnit: businessUnit,
          divisions: divisions,
        });
        return new Set(
          Object.entries(resp.permissions)
            .filter(([key, value]) => value)
            .map(([key]) => key as Permission),
        );
      } catch (error) {
        console.error('Error checking user permissions:', error);
        if (
          error instanceof UserNotFoundException ||
          error instanceof UserInactiveException
        ) {
          return new Set<Permission>();
        }
        throw error;
      }
    },
  });
